import React from 'react';
import { connect } from 'react-redux';
import Table from '../material-ui/Table/Table';
import CustomTabs from '../material-ui/CustomTabs/CustomTabs';
import GridContainer from '../material-ui/Grid/GridContainer';
import Button from '../material-ui/CustomButtons/Button';
import moment from 'moment';
import { messageDeleteAction } from '../../store/messages/actions';
import { statusSeite } from '../../models/mediumTypeEnum';

class MediumMessageTable extends React.Component {
  componentDidMount() {
  }

  deleteMessage = (messageId) => {
    const { messages, messageDeleteAction } = this.props;
    const messageIndex = messages.indexOf(messages.find(message => message.id === messageId));

    if (messageIndex !== -1) messages.splice(messageIndex, 1);

    messageDeleteAction({
      id: messageId
    });
  };

  render() {
    const { messages, mediumTypes, loading, classes, footer, handleMediumTypeChange, rowsLimit } = this.props;

    return (
      <GridContainer>
        {loading && messages.length === 0 && (
          <span>Loading...</span>
        )}

        <CustomTabs
          title="Verschickte Nachrichten"
          subtitle="Übersicht der letzten Nachrichten"
          headerColor="primary"
          classes={classes}
          onChange={handleMediumTypeChange}
          tabs={mediumTypes.map(mediumType => {
            const typeMessages = messages.filter(x => x.medium && x.medium.id === mediumType.id).slice(0, rowsLimit);
            const isShortMessages = typeMessages.every(x => !x.title);
            const isStatusSeite = mediumType.id === statusSeite;
            const tableColumns = ['Text', 'Datum', isStatusSeite ? 'Gültig bis' : 'Gesendet'];

            if (!isShortMessages) tableColumns.unshift('Titel');

            if (mediumType.id === statusSeite)
              tableColumns.push('Aktionen');

            return ({
              tabKey: mediumType.id,
              tabName: mediumType.name,
              tabMeta: {
                icon: mediumType.icon
              },
              tabContent: (
                <Table
                  tableHeaderColor="warning"
                  tableHead={tableColumns}
                  tableData={typeMessages.map(message => {
                    const data = [
                      message.text,
                      new Date(message.createdAt).toLocaleDateString(),
                      isStatusSeite
                        ? (message.validUntil ? moment(message.validUntil).format('DD.MM.YYYY, HH:mm') : '—')
                        : (message.receivers || 0)
                    ];

                    if (!isShortMessages) data.unshift(message.title);

                    if (message.medium.id === statusSeite)
                      data.push(<Button color="primary" className={classes.buttonSlim}
                        onClick={() => this.deleteMessage(message.id)}>Löschen</Button>);

                    return data;
                  })}
                />
              )
            });
          })}
          footer={footer}
        />
      </GridContainer>
    );
  }
}

const mapStateToProps = ({ messages }) => ({
  messages: messages.data
});


const mapDispatchToProps = dispatch => ({
  messageDeleteAction: (payload) => dispatch(messageDeleteAction(payload))
});


export default connect(mapStateToProps, mapDispatchToProps)(MediumMessageTable);
